import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_search from '@/locales/keys/i18n_page_search.json';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useTranslation } from 'react-i18next';

export function SButtonHideUnusedSearches() {
  const dispatch = use_dispatch();

  const { page_search_hide_unused, page_search_show_history } = use_slice_ui(['page_search_hide_unused', 'page_search_show_history']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SEARCH);

  const onClick = () => {
    dispatch(LOCAL__ui_set_boolean({ value: !page_search_hide_unused, key: 'page_search_hide_unused' }));
  };

  const render_button = () => {
    let out = <></>;

    if (page_search_show_history) {
      out = (
        <UI_PRIMITIVE__tooltip
          tooltip_title={
            page_search_hide_unused
              ? `${t(i18n_page_search.sidebar.button.hide_unused_values.tooltip_show)}`
              : `${t(i18n_page_search.sidebar.button.hide_unused_values.tooltip_hide)}`
          }
          side="right"
        >
          <UI_PRIMITIVE__button_with_icon_animated
            className="w-11"
            size="square-10"
            variant="no-border-on-bar"
            iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
            iconClassNameHovered="!text-bar-foreground"
            onClick={onClick}
            renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
            Icon={page_search_hide_unused ? ICON__eye_solid : ICON__eye_slash_solid}
          />
        </UI_PRIMITIVE__tooltip>
      );
    } else {
      out = <PLACEHOLDER_BUTTON__bar />;
    }

    return out;
  };

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_SEARCH_VIEW)) return <PLACEHOLDER_BUTTON__bar />;

  return render_button();
}
